import { afterNextRender, Component, effect, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { AppConfigService } from '@core/services/config/app-config.service';
import { InitAppService } from '@core/services/config/init-app.service';
import { SeoService } from 'src/app/services/seo/seo.service';
import { BannerPromoService } from 'src/app/services/banner-promo/banner-promo.service';

import { EmblaCarouselComponent } from './carousel/embla-carousel/embla-carousel.component';
import { EmpCarouselLastPosts } from '@components/shared/emp-carousel-last-posts/emp-carousel-last-posts.component';
import { EmpCarouselVetrinaComponent } from '@components/shared/emp-carousel-vetrina/emp-carousel-vetrina.component';
import { EmpCarouselCategorieComponent } from '@components/shared/emp-carousel-categorie/emp-carousel-categorie.component';
import { SlideComponent } from './slide/slide.component';
import { FadeInUpDirective } from '@components/shared/fade-in-up.directive';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';
import { ContactFormComponent } from '@components/shared/contact/contact-form.component';
import { RouterLink } from '@angular/router';

declare const bootstrap: any;
@Component({
    selector: 'app-home',
    imports: [
        EmblaCarouselComponent,
        EmpCarouselCategorieComponent,
        EmpCarouselVetrinaComponent,
        EmpCarouselLastPosts,
        FadeInUpDirective,
        SlideComponent,
        TranslatePipe,
        ContactFormComponent,
        RouterLink
    ],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {

    appConfig          = inject(AppConfigService);
    seoService         = inject(SeoService);
    titleService       = inject(Title);
    metaService        = inject(Meta);
    private dom        = inject(DOCUMENT);
    private sanitizer  = inject(DomSanitizer);

    protected readonly bannerService = inject(BannerPromoService);
    private initAppService = inject(InitAppService);

    show_blog_item: boolean = false;

    // Testo SEO homepage: stato espansione "Leggi di più"
    protected seoExpanded = signal(false);

    // Per ora il blocco SEO è solo in italiano
    protected get isItalian(): boolean {
        return this.initAppService.localeId.toLowerCase().startsWith('it');
    }

    protected get testoSafe(): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(this.bannerService.testo());
    }

    constructor() {
        /* effect(() => {
            if (!this.bannerService.showPopup() || !this.appConfig.cli()) return;

            const modalEl = this.dom.getElementById('promoModal');
            if (!modalEl) return;

            const modal = (window as any).bootstrap.Modal.getOrCreateInstance(modalEl);
            modal.show();
        }); */
        afterNextRender(() => {
                if (!this.bannerService.showPopup() || !this.appConfig.cli()) return;

                const modalEl = this.dom.getElementById('promoModal');
                if (!modalEl) return;

                // dispose eventuale istanza precedente prima di ricrearla
                bootstrap.Modal.getInstance(modalEl)?.dispose();
                bootstrap.Modal.getOrCreateInstance(modalEl).show();
            });

    }

    ngOnInit() {
        this.show_blog_item = this.appConfig.hasBlog();
        this.seoApply();
    }

    seoApply() {
        this.addMetaTag();

        // canonical — homepage sempre con trailing slash
        this.seoService.updateCanonicalUrl('https://' + this.dom.location.hostname + '/');

        const hostname = this.dom.location.hostname;
        const parts = hostname.split('.');
        const ext = parts.slice(-2).join('.') === 'co.uk'
            ? 'co.uk'
            : parts[parts.length - 1];
        const base_domain = 'https://' + hostname.slice(0, hostname.lastIndexOf('.' + ext)) + '.';

        this.seoService.addAlternateUrl(base_domain + 'it/', 'it-IT');
        this.seoService.addAlternateUrl(base_domain + 'fr/', 'fr-FR');
        this.seoService.addAlternateUrl(base_domain + 'de/', 'de-DE');
        this.seoService.addAlternateUrl(base_domain + 'es/', 'es-ES');
        this.seoService.addAlternateUrl(base_domain + 'com/', 'en-US');
        this.seoService.addAlternateUrl(base_domain + 'co.uk/', 'en-GB');
        this.seoService.addAlternateUrl(base_domain + 'com/', 'x-default');
    }

    addMetaTag() {
        this.titleService.setTitle(this.appConfig.translate('meta.title'));
        this.metaService.updateTag({ name: 'description', content: this.appConfig.translate('meta.description') });
    }

}